'use client';

import { Select, MenuItem } from '@mui/material';
import { usePathname, useRouter } from '@/navigation';

interface Props {
  years: number[];
}

export function YearSelectFilter({ years }: Props) {
  const router = useRouter();
  const pathname = usePathname();
  return (
    <Select
      defaultValue={years[0]}
      onChange={event => {
        if (!event.target.value) return;
        // Navigate to new URL based on selected year
        router.push(`${pathname}?year=${event.target.value}`);
      }}
    >
      {years.map(year => (
        <MenuItem key={year} value={year}>
          {year}
        </MenuItem>
      ))}
    </Select>
  );
}
